import * as React from 'react';
import styled from 'styled-components';

interface SVGProps {
  fillColor?: string;
  size?: string;
  color?: string;
  children: any;
  width?: string;
  height?: string;
  viewBox?: string;
  fill?: string;
  xmlns?: string;
  id?: string;
  xlinkHref?: string;
  xmlnsXlink?: string;
}

export const SVGIconRender = styled.svg<SVGProps>`
  color: ${(props) => (props.color ? props.color : 'black')};
  fill: transparent !important;
  pointer-events: none;

  ${(props) =>
    props.size === 'xs' &&
    `
      width: 12px;
      height: 12px;
    `}

  ${(props) =>
    props.size === 'sm' &&
    `
      width: 16px;
      height: 16px;
    `}

  ${(props) =>
    props.size === 'md' &&
    `
      width: 20px;
      height: 20px;
    `}

  ${(props) =>
    props.size === 'lg' &&
    `
      width: 24px;
      height: 24px;
    `}

  ${(props) =>
    props.size === 'slg' &&
    `
      width: 32px;
      height: 32px;
    `}

  ${(props) =>
    props.size === 'xl' &&
    `
      width: 38px;
      height: 38px;
    `}

  ${(props) =>
    props.size === 'xxl' &&
    `
      width: 70px;
      height: 70px;
    `}

  ${(props) =>
    props.size === 'xxxl' &&
    `
      width: 140px;
      height: 140px;
    `}
`;

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

export type { IconProps, SVGProps };
